import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserChangeActivationState = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [changeActivationStateLoading, setChangeActivationStateLoading] =
    useState(false);

  const changeActivationStateRequest = (payload, onSuccess) => {
    setChangeActivationStateLoading(true);
    axiosClient
      .put(`SettingAccount/User/UserChangeActivationState`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`با موفقیت به روزرسانی شد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setChangeActivationStateLoading(false));
  };
  return { changeActivationStateRequest, changeActivationStateLoading };
};

export default useUserChangeActivationState;
